import React, { memo } from 'react';
import Loader from 'src/components/Loader';
import styles from './styles.scss';

// eslint-disable-next-line react/display-name
export default memo(() => <Loader className={styles.loader} />);
